<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="card card-rounded card-transparent">
                    <div class="card-header">{{transEdit('book')}}</div>
                    <div class="card-body">
                        <button class="btn btn-secondary" @click="showFilters = !showFilters"><i class="fa fa-filter"></i> {{transEdit('filter')}}</button>
                        <div class="row mt-2" v-if="showFilters">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>{{transEdit('locations')}}</label>
                                    <multiselect
                                            v-model="selectedLocations"
                                            :options="filterLocations"
                                            track-by="address"
                                            label="address"
                                            :showLabels="false"
                                            :hideSelected="true"
                                            placeholder="Välj lokal"
                                            selectLabel=""
                                            deselectLabel=""
                                            :multiple="true">
                                    </multiselect>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>{{transEdit('therapists')}}</label>
                                    <multiselect
                                            v-model="selectedTherapists"
                                            :options="filterTherapists"
                                            track-by="name"
                                            label="name"
                                            :showLabels="false"
                                            :hideSelected="true"
                                            placeholder="Välj terapeut"
                                            selectLabel=""
                                            deselectLabel=""
                                            :multiple="true">
                                    </multiselect>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>{{transEdit('treatments')}}</label>
                                    <multiselect
                                            v-model="selectedTreatments"
                                            :options="filterTreatments"
                                            track-by="name"
                                            label="name"
                                            :showLabels="false"
                                            :hideSelected="true"
                                            placeholder="Välj behandling"
                                            selectLabel=""
                                            deselectLabel=""
                                            :multiple="true">
                                    </multiselect>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12 d-flex justify-content-center">
                                <flash></flash>
                                <calendar :ajax-url="ajaxUrl" date-key="start" @daySelected="setDate" ref="calendar" class="d-flex justify-content-center"></calendar>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="d-flex flex-row" v-if="date">
                                    <h4 class="d-inline mt-4 mt-lg-0 mr-auto">{{days[getDay(date.date)]}} {{date.date.format('DD MMMM')}}</h4>
                                    <button type="button" class="btn btn-outline-primary mt-4"
                                        @click="selectTherapistForDay(date.events)">
                                        <i class="fa fa-user"></i>{{transEdit('substitute-for-day')}}</button>
                                </div>
                                <div v-if="date" class="schedule-list">
                                    <div v-for="schedule in date.events" class="border mt-2 mb-2 p-2 schedule-slot rounded" >
                                        <div class="col-lg-8">
                                            <div class="row">
                                                <div class="h5">{{getTime(schedule.start)}} - {{getTime(schedule.end)}}, <span class="text-black-50 text-small">{{schedule.location.name}}</span></div>
                                            </div>
                                            <div class="row">
                                                <div class="col-lg-4">
                                                    <template v-if="schedule.original_therapist">
                                                        <div>
                                                            <s><img class="round-profile-picture" :src="'/therapist_profile_picture/'+schedule.original_therapist.profile_picture_path"> {{schedule.original_therapist.user.name}}</s>
                                                        </div>
                                                        <div>
                                                            <img class="round-profile-picture" :src="'/therapist_profile_picture/'+schedule.therapist.profile_picture_path"> {{schedule.therapist.user.name}}
                                                        </div>
                                                    </template>
                                                    <template v-else>
                                                        <img class="round-profile-picture" :src="'/therapist_profile_picture/'+schedule.therapist.profile_picture_path"> {{schedule.therapist.user.name}}
                                                    </template>
                                                </div>
                                                <div class="col-lg-3" v-if="schedule.booking">
                                                    {{schedule.booking.treatment.name}}
                                                </div>
                                                <div class="col-lg-5" v-if="schedule.booking">
                                                    {{transEdit('booked-by')}}: <a :href="'/customer/' + schedule.booking.user.role.id" target="_blank">{{schedule.booking.user.name}}</a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="d-block text-right">
                                            <button class="btn btn-sm btn-outline-primary d-inline" @click="selectTherapist(schedule)"><i class="fa fa-user"></i> {{transEdit('add-substitute')}}</button>
                                            <template v-if="schedule.original_therapist">
                                                <button class="btn btn-sm btn-outline-danger d-inline" @click="removeSubstitute(schedule)"><i class="fa fa-user-times"></i> {{transEdit('remove-substitute')}}</button>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                                <div v-else class="d-flex justify-content-center align-content-center"><div class="h4 text-black-50 mt-4 mt-lg-0">{{transEdit('choose-day')}}</div></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import RemoveSubstituteModal from './RemoveSubstituteModal.vue'
    import SubstituteModal from './SubstituteModal.vue'
    import SubstituteForDayModal from './SubstituteForDayModal.vue'

    export default {
        name: "admin-calendar",
        props: ['therapists', 'treatments', 'reservations', 'user_id', 'cannot_book', 'company', 'locations'],
        data(){
            return {
                date: null,
                selectedSchedule: null,
                selectedLocations: [],
                selectedTherapists: [],
                selectedTreatments: [],
                showFilters: false,
                days: ["Söndag", "Måndag", "Tisdag", "Onsdag", "Torsdag", "Fredag", "Lördag"],
            }
        },
        computed: {
            ajaxUrl(){
                let first = true;
                let url = '/book/filterevents';

                let symbol = '?';

                this.selectedLocations.forEach((location) => {
                    url += symbol+'location_ids[]='+location.id;
                    if(first){
                        symbol = '&';
                        first = false;
                    }
                });

                this.selectedTherapists.forEach((therapist) => {
                    url += symbol+'therapist_ids[]='+therapist.id;
                    if(first){
                        symbol = '&';
                        first = false;
                    }
                });

                this.selectedTreatments.forEach((treatment) => {
                    url += symbol+'treatment_ids[]='+treatment.id;
                    if(first){
                        symbol = '&';
                        first = false;
                    }
                });

                url += symbol+'company_id='+this.company.id;

                return url;
            },
            filterLocations() {
                let simplifiedLocations = [];
                if(this.locations){
                    this.locations.forEach((location) => {
                        let tempAddressString = location.address;
                        if (location.city) {
                            tempAddressString += ' ' + location.city.name;
                        }
                        simplifiedLocations.push({
                            id: location.id,
                            address: tempAddressString,
                        });
                    });
                }

                return simplifiedLocations;
            },
            filterTherapists() {
                let simplifiedTherapists = [];
                if(this.therapists){
                    this.therapists.forEach((therapist) => {
                        simplifiedTherapists.push({
                            id: therapist.id,
                            name: therapist.user.name,
                        });
                    });
                }
                return simplifiedTherapists;
            },
            filterTreatments() {
                let simplifiedTreatments = [];
                if(this.treatments){
                    this.treatments.forEach((treatment) => {
                        simplifiedTreatments.push({
                            id: treatment.id,
                            name: treatment.name,
                        });
                    });
                }
                return simplifiedTreatments;
            },
        },
        methods: {
            setDate(date){
                this.date = date;
            },
            getDay(date){
                return new Date(date).getDay()
            },
            getDateTime(dateString){
                return moment(dateString).format('YYYY-MM-DD HH:mm')
            },
            getTime(dateString){
                return moment(dateString).format('HH:mm')
            },
            selectTherapist(schedule){
                this.selectedSchedule = schedule;
                this.$modal.show(SubstituteModal, {
                    schedule:  this.selectedSchedule
                }, {
                    'width': '100%',
                    'max-width': 800,
                    'adaptive': true,
                    'clickToClose': false,
                }, {
                    'before-close': this.closeModal
                })
            },
            removeSubstitute(schedule){
                this.selectedSchedule = schedule;
                this.$modal.show(RemoveSubstituteModal, {
                    schedule:  this.selectedSchedule
                }, {
                    'width': '100%',
                    'max-width': 800,
                    'adaptive': true,
                    'clickToClose': false,
                }, {
                    'before-close': this.closeModal
                })
            },
            selectTherapistForDay(schedules){
                this.$modal.show(SubstituteForDayModal, {
                    schedules: schedules
                }, {
                    'width': '100%',
                    'max-width': 800,
                    'height': '100%',
                    'max-height': 400,
                    'adaptive': true,
                    'clickToClose': false,
                }, {
                    'before-close': this.closeModal
                })
            },
            closeModal (event) {
                this.$refs.calendar.ajaxEvents();
            }
        }
    }
</script>
<style scoped>
    .schedule-slot{
        display: flex;
        justify-content: space-between;
    }

    .text-small {
        font-size: 0.6em;
    }
</style>
